import { formatIOPreview } from '@/utils/trace.utils'

/** input/output 单元格，悬停显示完整内容 */
export function TraceIOCell({ value }: { value: unknown }) {
  const preview = formatIOPreview(value)
  return (
    <td className="px-3 py-3 max-w-[280px] truncate text-muted-foreground" title={preview || undefined}>
      {preview || '-'}
    </td>
  )
}
